import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Aligner } from '@alfa-bank/site-aligner';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { GeoInfoConsumer } from '@alfa-bank/site-geo-info';

import { GeoInformerTitleDesktop as GeoInformerTitle } from '../components/geo-informer-title/desktop';
import type { TCcCardGeoDeliveryDesktop, IDepsDesktop } from '../models';
import { GeoInformerComponent } from '../components/geo-informer-component';

import styles from './styles.css';
import { CcCardGeoDeliveryDesktop as Component } from './cc-card-geo-delivery-desktop';

export const CcCardGeoDeliveryDesktop = createWidgetWithErrorBoundary<
    IDepsDesktop,
    TCcCardGeoDeliveryDesktop
>({
    Block,
    Layout,
    Text,
    Grid,
    Aligner,
    useNamedContainers,
    GeoInformerTitle,
    GeoInformerComponent,
    GeoInfoConsumer,
    styles,
})(Component);
